import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-orange-50 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22dai8ush2fuc">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yet7805xkl7n">
        <div className="text-center" data-id="element-22" data-mp="1anxn7p7puuay">
          <span className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-green-950" data-id="element-23" data-mp="1aoyvxn19f4pi">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jhak128wig2b" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-green-950 sm:text-4xl" data-id="element-25" data-mp="1epsk8him6lix">
            The {totalBonuses} exclusive bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="mz4l1b0i3q7w">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border border-stone-200 bg-white p-6 shadow-sm ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29rtd9t78vm6j" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1vrijoiejvtho">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="20roeg7g49w3z">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-green-900 text-amber-400" data-id="element-30" data-mp="20q3iqei2g74j">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="25o53r4z1ygin" />
                    </span>
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-stone-500" data-id="element-32" data-mp="3c8wigrmupa7m">Bonus {bonus.number}</p>
                  </div>
                  <p className="whitespace-nowrap text-xs font-bold text-stone-600" data-id="element-33" data-mp="1h2m153sa1buw">
                    <span className="line-through" data-id="element-34" data-mp="1c4tzvj5qsde1">Real value {bonus.value}</span>
                    <span className="ml-2 rounded-md bg-amber-500 px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-green-950" data-id="element-35" data-mp="1q43e4dae0xfd">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-bold leading-tight text-green-950" data-id="element-36" data-mp="ydyyerxkoykh">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-stone-600" data-id="element-37" data-mp="tevw3f8z96g7">{bonus.description}</p>

                {bonus.items && <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-38" data-mp="177c1gmpcpgka">
                    {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-stone-900" data-id="element-39" data-mp="eowvz6xv3ky3">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-700" aria-hidden="true" data-id="element-40" data-mp="anbe176h0gh1" />
                        {item}
                      </li>)}
                  </ul>}

                {bonus.groups && <div className="mt-4 grid gap-6 md:grid-cols-2" data-id="element-41" data-mp="5bo1qycq41nq">
                    {bonus.groups.map(group => <div key={group.label} data-id="element-42" data-mp="3moi69iq7p97p">
                        <p className="text-sm font-bold text-green-950" data-id="element-43" data-mp="3rowfh43jup7b">{group.label}</p>
                        <ul className="mt-2 grid gap-1.5" data-id="element-44" data-mp="j9cq4g601qxj">
                          {group.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-stone-900" data-id="element-45" data-mp="o7xp6c9im4ke">
                              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-700" aria-hidden="true" data-id="element-46" data-mp="9aokkgv7b4aq" />
                              {item}
                            </li>)}
                        </ul>
                      </div>)}
                  </div>}

                <div className="flex-1" data-id="element-47" data-mp="2z2bow5uweh4t" />
                {bonus.cycle && <div className="mt-5 rounded-lg border-l-4 border-amber-800 bg-stone-100 px-4 py-3" data-id="element-48" data-mp="3f8yaudb49h88">
                    <p className="text-sm font-semibold text-stone-700" data-id="element-49" data-mp="3agoh0m6vrx0o">The guide follows a structured teaching cycle:</p>
                    <ol className="mt-2 flex flex-wrap items-center gap-x-1.5 gap-y-2 text-xs font-extrabold uppercase tracking-wide text-green-950" data-id="element-50" data-mp="35g93numlmpip">
                      {bonus.cycle.map((step, stepIndex) => <li key={step} className="inline-flex items-center gap-1.5" data-id="element-51" data-mp="1zabsycx1wto" data-mpi={stepIndex}>
                          <span className="rounded-md bg-white px-2 py-1 ring-1 ring-stone-200" data-id="element-52" data-mp="3t5uzq97ocomh">{step}</span>
                          {stepIndex < bonus.cycle!.length - 1 && <ArrowRightIcon className="h-3.5 w-3.5 text-amber-700" aria-hidden="true" data-id="element-53" data-mp="3j98g1nr343m1" />}
                        </li>)}
                    </ol>
                  </div>}
                {bonus.benefit && <p className="mt-4 rounded-lg border-l-4 border-stone-500 bg-stone-100 px-4 py-3 text-sm font-semibold text-stone-700" data-id="element-54" data-mp="ndvhv4j51w2a">
                    {bonus.benefit}
                  </p>}
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl bg-green-900 px-6 py-6 text-center shadow-lg sm:flex-row sm:text-left" data-id="element-55" data-mp="121qa6jt8hyeu">
          <div data-id="element-56" data-mp="172w3aiqt3now">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-green-100" data-id="element-57" data-mp="1b1v9e6o9xqhx">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 text-2xl font-extrabold text-green-100/70 line-through decoration-red-300 decoration-2" data-id="element-58" data-mp="1g213rulxhr3p">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-59" data-mp="3htwarwx8p7fl">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-green-100" data-id="element-60" data-mp="3huxl1z6flpw9">Your price today</p>
            <p className="mt-1 text-3xl font-extrabold text-amber-400" data-id="element-61" data-mp="3er00orhchtp9">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-stone-700" data-id="element-62" data-mp="3apo6e8nj0kaq">
          Only included in this offer
        </p>
      </div>
    </section>;
}